(function () {
  const SIZE_ALIASES = {
    'S/M': ['[s/m]', '[s:m]', '[sm]', 'size: s/m', 'size: s:m'],
    L: ['[l]', 'size: l'],
    XL: ['[xl]', 'size: xl'],
  };

  const FIT_NOTES = {
    'sky-bloom': {
      'S/M': 'The model is wearing size S/M. Her height is 170 cm and waist size is 82 cm.',
      L: 'The model is wearing size L. Her height is 153 cm and waist size is 82 cm.',
      XL: 'The model is wearing size XL. Her height is 155 cm and waist size is 124 cm.',
    },
    moonstone: {
      'S/M': 'The model is wearing size S/M. Her height is 170 cm and waist size is 82 cm.',
      L: 'The model is wearing size L. Her height is 169 cm and waist size is 80 cm.',
      XL: 'The model is wearing size XL. Her height is 155 cm and waist size is 124 cm.',
    },
    'cotton-candy': {
      'S/M': 'The model is wearing size S/M. Her height is 170 cm and waist size is 82 cm.',
      L: 'The model is wearing size L. Her height is 156 cm and waist size is 87 cm.',
      XL: 'The model is wearing size XL. Her height is 155 cm and waist size is 124 cm.',
    },
  };

  function normalizeSize(value) {
    if (!value) return '';
    const size = String(value).trim().toLowerCase();
    if (size === 'xl' || size === 'x-large') return 'XL';
    if (size === 'l' || size === 'large') return 'L';
    if (size === 's/m' || size === 's:m' || size === 'sm' || size === 's-m') return 'S/M';
    return '';
  }

  function selectedSizeFromVariant(variant) {
    const option = variant?.selected_options?.find((item) => /size/i.test(item.name));
    return normalizeSize(option?.value || variant?.option1 || variant?.title);
  }

  function selectedSizeFromDom(productInfo) {
    const selectedVariantJson = productInfo.querySelector('variant-selects [data-selected-variant]')?.textContent;

    if (selectedVariantJson) {
      try {
        return selectedSizeFromVariant(JSON.parse(selectedVariantJson));
      } catch (_error) {
        // Fall through to checked controls below.
      }
    }

    const checkedInput = productInfo.querySelector('variant-selects input[type="radio"]:checked');
    const selectedOption = productInfo.querySelector('variant-selects select option:checked');
    return normalizeSize(checkedInput?.value || selectedOption?.value);
  }

  function sizeFromText(text) {
    const normalized = String(text || '').toLowerCase();

    if (/\[(?:xl)(?:[\s:_-]*\d{1,3})?\]/i.test(normalized) || /(?:^|[^a-z0-9])xl[\s:_-]*\d{1,3}(?:[^a-z0-9]|$)/i.test(normalized)) {
      return 'XL';
    }

    if (/\[(?:l)(?:[\s:_-]*\d{1,3})?\]/i.test(normalized) || /(?:^|[^a-z0-9])l[\s:_-]*\d{1,3}(?:[^a-z0-9]|$)/i.test(normalized)) {
      return 'L';
    }

    if (
      /\[(?:s\/m|s:m|s-m|sm)(?:[\s:_-]*\d{1,3})?\]/i.test(normalized) ||
      /(?:^|[^a-z0-9])(?:s\/m|s:m|s-m|sm)[\s:_-]*\d{1,3}(?:[^a-z0-9]|$)/i.test(normalized)
    ) {
      return 'S/M';
    }

    for (const [size, aliases] of Object.entries(SIZE_ALIASES)) {
      if (aliases.some((alias) => normalized.includes(alias))) return size;
    }

    return '';
  }

  function mediaText(item) {
    return item.querySelector('img')?.alt || item.textContent || '';
  }

  function itemSize(item) {
    return sizeFromText(mediaText(item));
  }

  function itemOrder(item, selectedSize) {
    const text = String(mediaText(item) || '').toLowerCase();
    const sizePatterns = {
      'S/M': ['s/m', 's:m', 's-m', 'sm'],
      L: ['l'],
      XL: ['xl'],
    };
    const tokens = sizePatterns[selectedSize] || [];

    for (const token of tokens) {
      const escapedToken = token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const bracketMatch = text.match(new RegExp(`\\[${escapedToken}[\\s:_-]*(\\d{1,3})\\]`, 'i'));
      if (bracketMatch) return Number(bracketMatch[1]);

      const inlineMatch = text.match(new RegExp(`(?:^|[^a-z0-9])${escapedToken}[\\s:_-]*(\\d{1,3})(?:[^a-z0-9]|$)`, 'i'));
      if (inlineMatch) return Number(inlineMatch[1]);
    }

    return Number.POSITIVE_INFINITY;
  }

  function orderedItems(items, selectedSize) {
    return items
      .map((item, index) => ({ item, index, order: itemOrder(item, selectedSize) }))
      .sort((a, b) => a.order - b.order || a.index - b.index)
      .map(({ item }) => item);
  }

  function updateVisibleCount(gallery, count) {
    gallery.querySelectorAll('.slider-counter--total').forEach((counter) => {
      counter.textContent = String(count);
    });

    gallery.querySelectorAll('.slider-counter--current').forEach((counter) => {
      counter.textContent = '1';
    });
  }

  function filterGallery(productInfo, selectedSize) {
    const gallery = productInfo.querySelector('media-gallery');
    if (!gallery || !selectedSize) return;

    const slides = Array.from(gallery.querySelectorAll('.product__media-list li[data-media-id]'));
    const thumbnails = Array.from(gallery.querySelectorAll('.thumbnail-list li[data-target]'));
    const matchingSlides = orderedItems(
      slides.filter((slide) => itemSize(slide) === selectedSize),
      selectedSize
    );

    if (!matchingSlides.length) {
      [...slides, ...thumbnails].forEach((item) => {
        item.hidden = false;
        item.style.display = '';
      });
      updateVisibleCount(gallery, slides.length);
      return;
    }

    const visibleMediaIds = new Set(matchingSlides.map((slide) => slide.dataset.mediaId));
    const visibleOrder = new Map(matchingSlides.map((slide, index) => [slide.dataset.mediaId, index]));
    const matchingThumbnails = thumbnails
      .filter((thumbnail) => visibleMediaIds.has(thumbnail.dataset.target))
      .sort((a, b) => visibleOrder.get(a.dataset.target) - visibleOrder.get(b.dataset.target));

    matchingSlides.forEach((slide) => slide.parentElement?.appendChild(slide));
    matchingThumbnails.forEach((thumbnail) => thumbnail.parentElement?.appendChild(thumbnail));

    slides.forEach((slide) => {
      const visible = visibleMediaIds.has(slide.dataset.mediaId);
      slide.hidden = !visible;
      slide.style.display = visible ? '' : 'none';
      slide.classList.toggle('is-active', false);
    });

    thumbnails.forEach((thumbnail) => {
      const visible = visibleMediaIds.has(thumbnail.dataset.target);
      thumbnail.hidden = !visible;
      thumbnail.style.display = visible ? '' : 'none';
      thumbnail.querySelector('button')?.removeAttribute('aria-current');
    });

    const firstVisible = matchingSlides[0];
    firstVisible.classList.add('is-active');
    thumbnails
      .find((thumbnail) => thumbnail.dataset.target === firstVisible.dataset.mediaId)
      ?.querySelector('button')
      ?.setAttribute('aria-current', 'true');

    gallery.setActiveMedia?.(firstVisible.dataset.mediaId, true);
    updateVisibleCount(gallery, matchingSlides.length);
  }

  function updateFitNote(productInfo, selectedSize) {
    const note = productInfo.querySelector('[data-allio-size-fit-note]');
    const text = productInfo.querySelector('[data-allio-size-fit-note-text]');
    if (!note || !text) return;

    const productHandle = note.dataset.productHandle;
    const fitText = FIT_NOTES[productHandle]?.[selectedSize] || '';

    text.textContent = fitText;
    note.hidden = !fitText;
  }

  function updateProduct(productInfo, variant) {
    const selectedSize = selectedSizeFromVariant(variant) || selectedSizeFromDom(productInfo);
    updateFitNote(productInfo, selectedSize);
    window.requestAnimationFrame(() => filterGallery(productInfo, selectedSize));
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('product-info').forEach((productInfo) => updateProduct(productInfo));
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const productInfo = document.getElementById(`MainProduct-${data.sectionId}`);
      if (productInfo) updateProduct(productInfo, data.variant);
    });
  }

  document.addEventListener('change', (event) => {
    const productInfo = event.target.closest?.('product-info');
    if (productInfo) updateProduct(productInfo);
  });
})();
